import { render } from "./CameraIcon.vue?vue&type=template&id=680b239c"
import script from "./CameraIcon.vue?vue&type=script&lang=js"
export * from "./CameraIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__